export const ACADEMY_SUPPORTED_LANGUAGES = ['EN', 'ES', 'DE', 'JA', 'FR', 'PT'];